
import {finalize} from 'rxjs/operators';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Dossier } from '../dossier/dossier';
import { DossierModel } from '../dossier-model/dossier-model';
import { RecordLink } from '../record-link/record-link';
import { DossierTree, TreeItemWithRecord } from '../dossier/tree';
import { each, find, remove } from 'lodash';
import { SimpleItem } from '../dossier/tree/simple-item';
import { DossierService } from '../dossier/dossier.service';
import { NotifierService } from '../ui/alert';


@Component({
  selector: 't-select-tree',
  templateUrl: './select-tree.component.html',
})
export class SelectTreeComponent implements OnChanges {
  
  @Input()
  dossier: Dossier

  @Input()
  dossierModel: DossierModel

  @Input() selectedLinks: RecordLink[]
  @Output() selectedLinksChange = new EventEmitter<RecordLink[]>();

  tree: DossierTree = null;
  loading: boolean = false;

    constructor(
    private dossierService: DossierService,
    private notifier: NotifierService,
  ) {}


  ngOnChanges(changes: SimpleChanges) {
    if(changes.dossier) {
      
      // No dossier
      if(!this.dossier) {
        this.tree = null;
      }

      // Dossier was loaded with links
      else if(this.dossier.links) {
        this.buildDossierTree();
      }

      // Dossier was loaded without links
      else {
        this.notifier.updateProgress(20);

        this.tree = null;
        this.loading = true;

        this.dossierService
          .dossier(this.dossier.id).pipe(
          finalize(() => {
            this.notifier.endProgress();
          }))
          .subscribe((dossier) => {
            if (dossier) {
              this.dossier = dossier;

              this.buildDossierTree();
            }
          });
      }
    }
  }

  private buildDossierTree() {
    
    this.tree = null;
    this.loading = true;

    // Attach models on each link
    each(this.dossier.links, link => {
      let target = find(this.dossierModel.targets, target => target.id === link.name);
      
      if (target) {
        link.model = target.link;
      }
    });
    
    let tree = new DossierTree(this.dossier, this.dossierModel);
    
    // Remove all data links
    remove(tree.rootItem.children, item => {
      let simpleItem = item as SimpleItem;

      return (simpleItem.target && simpleItem.target.link.link_type === 'DataLink');
    });

    // Check all items
    tree.visit((item) => item.checked = 'YES');

    this.tree = tree;
    this.loading = false;

    setTimeout(() => {
      this.emitSelectedLinksChange();
    }, 0);
  }

  emitSelectedLinksChange() {
    this.selectedLinksChange.emit(this.getSelectedLinks());
  }

  private getSelectedLinks() {
    let selectedLinks: RecordLink[] = [];

    this.tree.visit((item) => {
      if (item.checked !== 'YES') {
        return;
      }

      if (item.type === 'ROOT' || item.type === 'RECORD') {
        let ri = (item as any) as TreeItemWithRecord;
        selectedLinks.push((ri).link);
      }
    });

    return selectedLinks;
  }
}
